import React, { useMemo } from 'react';
import { useField } from 'formik';
import { observer } from 'mobx-react';
import { Form } from 'react-bootstrap';

import { DateField } from 'src/libs/ui-kit/inputs/Date/DateField';
import { FIOField } from 'src/libs/ui-kit/inputs/Dadata/components/FIOField';
import { SelectField } from 'src/libs/ui-kit';

import { DateTimeService } from 'src/services/DateTimeService';

import { USER_TYPE_OPTIONS, widgetLabels } from '../constants';
import { IUserProfileEditFrontend, USER_TAGS } from '../interfaces';
import { MultiSuggestField } from '../../../../../libs/ui-kit/inputs/Suggest';

// type TTenant = IUserProfileEditFrontend['tenant'];
type TIsBlocked = IUserProfileEditFrontend['isBlocked'];
type TBlockingReasonDescription = IUserProfileEditFrontend['blockingReasonDescription'];
type TBlockedAt = IUserProfileEditFrontend['blockedAt'];
type TCreatedAt = IUserProfileEditFrontend['createdAt'];

export const EditCustomerForm = observer(() => {
  // const [{ value }, , { setValue }] = useField<TTenant>('tenant');
  const [{ value: isBlocked }] = useField<TIsBlocked>('isBlocked');
  const [{ value: blockingReasonDescription }] = useField<TBlockingReasonDescription>('blockingReasonDescription');
  const [{ value: blockedAt }] = useField<TBlockedAt>('blockedAt');
  const [{ value: createdAt }] = useField<TCreatedAt>('createdAt');

  const maxBirthDate = useMemo(() => DateTimeService.addTime(-18, DateTimeService.Unit.Years), []);

  return (
    <>
      <FIOField name="fioData" />
      <DateField name="birthday" label="Дата рождения" placeholder="Введите дату рождения" maxDate={maxBirthDate} />
      <SelectField name="userType" label="Тип пользователя" disabled options={USER_TYPE_OPTIONS} />
      {/* <SuggestField
        disabled
        label="Арендатор"
        name="tenant"
        value={value}
        placeholder="Арендатор"
        optionLabelKey="name"
        optionValueKey="id"
        search={searchTenants}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onChange={setValue as any}
      /> */}
      {isBlocked && (
        <>
          <Form.Group>
            <div className="text-muted">{widgetLabels.profileBlockingStatus}</div>
            <div>{widgetLabels.profileBlocked}</div>
          </Form.Group>
          <Form.Group>
            <div className="text-muted">{widgetLabels.profileBlockingReason}</div>
            <div>{blockingReasonDescription}</div>
            <div>{blockedAt}</div>
          </Form.Group>
        </>
      )}
      <Form.Group>
        <div className="text-muted">{widgetLabels.profileCreationDate}</div>
        <div>{createdAt}</div>
      </Form.Group>
      <MultiSuggestField
        name="tags"
        label="Теги"
        optionLabelKey="key"
        optionValueKey="value"
        search={() =>
          Promise.resolve(
            Object.values(USER_TAGS).map((tag) => ({
              value: tag,
              key: tag,
            })),
          )
        }
      />
    </>
  );
});
